import i18n from "@/i18n";

const routes = {
  path: "/booking",
  name: "Booking",
  component: () =>
    import(/* webpackChunkName: "booking" */ "@/views/booking/Main"),
  children: [
    {
      path: "bookingdate",
      alias: "",
      name: "bookingDate",
      component: () =>
        import(/* webpackChunkName: "booking" */ "@/views/booking/bookingDate"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("title.setting.booking"),
        step: [
          i18n.t("menu.booking.booking"),
          // i18n.t("page.booking.booking_date"),
        ],
        menu_num: 2,
        sub_menu_num: 21,
        location: "/booking/bookingDate",
      },
    },
  ],
};

export default routes;
